import type { Column } from '@/components_deprecated'
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { cn } from '@/lib/utils'
import type { PropsWithChildren } from 'react'
import React from 'react'

/**
 * The timesheet rows still render plain `td`s (see `TimesheetTableRow`), so the
 * cell styling `TableCell` would provide is applied from here instead.
 */
const rowStyles = cn(
  '[&_tbody_td]:px-4 [&_tbody_td]:py-3',
  '[&_tbody_td]:align-middle [&_tbody_td]:font-medium [&_tbody_td]:whitespace-nowrap',
  '[&_tbody_tr:hover]:bg-neutral-100',
  // Separate rows along their top edge rather than the bottom, so that a row
  // can opt out of the separator above it — the summation row does.
  '[&_tbody_tr]:border-b-0',
  '[&_tbody_tr:not(:first-of-type)]:border-t [&_tbody_tr:not(:first-of-type)]:border-neutral-200'
)

interface TimesheetTableShellProps extends PropsWithChildren {
  columns: Column[]
}

/**
 * Shared table chrome for the timesheet tables: the card, the column headers
 * and the cell styling the hand-written rows rely on.
 */
export const TimesheetTableShell: React.FC<TimesheetTableShellProps> = ({
  children,
  columns,
}) => (
  <div className="px-4 rounded-xl bg-white shadow-card">
    <Table className={rowStyles}>
      <TableHeader>
        <TableRow>
          {columns.map(column => (
            <TableHead key={column.name}>
              {column.displayName || column.name}
            </TableHead>
          ))}

          {/* Extra column for the row menu */}
          <TableHead />
        </TableRow>
      </TableHeader>

      <TableBody>{children}</TableBody>
    </Table>
  </div>
)
